import {css} from 'lit';
export const styles = css`.input-text {
  position: relative;
  display: flex;
  flex-direction: column;
}
.input-text__input {
  width: 100%;
  height: 48px;
  min-width: 320px;
  background-color: var(--color-neutral-100);
  border-radius: var(--border-radius-default);
  border: var(--border-width-default) solid var(--color-neutral-300);
  padding: var(--spacing-size-3xs);
  box-sizing: border-box;
  color: var(--color-neutral-600);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-default);
}
.input-text__input::placeholder {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--color-neutral-300);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-default);
}
.input-text__input:hover {
  border: var(--border-width-default) solid var(--color-brand-300);
}
.input-text__input:hover::placeholder {
  color: var(--color-contrast-brand);
}
.input-text__input:focus-visible:not(:disabled) {
  outline-offset: 2px;
  outline: var(--color-contrast-focused) solid 2px;
}
.input-text__label {
  color: var(--color-neutral-600);
  font-family: var(--font-family-base);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-default);
  margin-bottom: 6px;
}
.input-text--disabled {
  pointer-events: none;
}
.input-text--disabled label {
  color: var(--color-neutral-300) !important;
}
.input-text--disabled input {
  color: var(--color-neutral-300) !important;
  background: rgba(191, 191, 191, var(--opacity-level-3)) !important;
  border: var(--border-width-default) solid var(--color-neutral-300) !important;
}
.input-text--error:not(.input-text--disabled) input {
  color: var(--color-feedback-danger-300) !important;
  border: var(--border-width-default) solid var(--color-feedback-danger-300) !important;
}
.input-text--error:not(.input-text--disabled) input::placeholder {
  color: var(--color-feedback-danger-300) !important;
}
.input-text--sm input {
  height: 36px !important;
}
.input-text--sm label {
  display: none;
}

.input-base-helper span#textarea-counter {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
}`;
export default styles;
